import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxBulletModule } from 'devextreme-angular/ui/bullet';
import { SimpleGridComponent } from './simple-grid.component';
import { SimpleGridService } from './simple-grid.service';
import { DxoMasterDetailModule } from 'devextreme-angular/ui/nested';




@NgModule({
  imports: [CommonModule, DxDataGridModule, DxBulletModule, DxoMasterDetailModule],
  declarations: [SimpleGridComponent],
  providers: [SimpleGridService],
  exports: [SimpleGridComponent]
})
export class SimpleGridModule { }
